// 引入配置文件
import configData from './conf.js'

/**
 * ios input 失去焦点时候页面不会滚回的初始位置  解决方法：
 *  */

export const goBottomBackFn = () => {
  setTimeout(() => {
    window.scrollTo(0, document.body.scrollTop + 1)
    document.body.scrollTop >= 1 && window.scrollTo(0, document.body.scrollTop - 1)
  }, 10)
}

/**
 * @returns {Object} 获取地址上的参数
 */
export const getUrlParam = (url) => {
  let theRequest = {}
  const str = url.substr(0)
  const strs = str.split('&')
  for (let i = 0; i < strs.length; i++) {
    theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
  }
  return theRequest
}

export const parseUrl2Obj = (url) => {
  let ret = {}
  if (url.indexOf('?') !== -1) {
    url = url.substr(url.indexOf('?') + 1)
    let strs = url.split('&')
    for (let i = 0; i < strs.length; i++) {
      ret[strs[i].split('=')[0]] = (strs[i].split('=')[1])
    }
  }
  return ret
}

/**
 * @returns {Boolean} 判断是否在微信
 */
export const isWeChat = () => {
  let isTure = false
  if (!navigator.userAgent.toLowerCase().match(/micromessenger/i)) {
    isTure = false
  }else {
    isTure = true
  }
  return isTure
}

/*
 *  {token: 1111, userId: 111} 将参数拼接 token=111&userId=111
 */
export const SortParams = data => {
  let param = ''
  for (let i in data) {
    if (param) {
      param += `&${i}=${data[i]}`
    } else {
      param += `${i}=${data[i]}`
    }
  }
  return param
}


// 判断设备类型
export const  getPhoneType = () => {
  let u = navigator.userAgent
  let ver = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/)
  let result = false
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
  if (isAndroid) {
    result = true
  }else {
    ver = parseInt(ver[1], 10)
    if (ver < 13) {
      result = true
    } else {
      result = false
    }
  }
  return result
}

// 判断是否IphoneX
export const getIphoneXType = () => {
  let ua = navigator.userAgent
  let result = false
  console.log('手机型号类型',ua)
  if (ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
    console.log('手机型号类型',window.screen.width, window.screen.height)
    if ((window.screen.width === 375 && window.screen.height === 812)
        || (window.screen.width === 375 && window.screen.height === 724)
        || (window.screen.width === 414 && window.screen.height === 896)
        || (window.screen.width === 414 && window.screen.height === 896)
        || (window.screen.width === 390 && window.screen.height === 844)
        || (window.screen.width >= 375 && window.screen.height >= 750)
    ) {
      result = true
    } else {
      result = false
    }
    return result
  }
}

// 时间格式化
export const formatDateUtil = (source, format) => {
  // 检查source是否为有效的Date对象
  if (!(source instanceof Date)) {
    console.warn('formatDateUtil: source不是Date对象', source);
    return '无效日期';
  }
  
  // 检查Date对象是否有效
  if (isNaN(source.getTime())) {
    console.warn('formatDateUtil: 无效的Date对象', source);
    return '无效日期';
  }

  let o = {
    'M+': source.getMonth() + 1, // 月份
    'd+': source.getDate(), // 日
    'H+': source.getHours(), // 小时
    'm+': source.getMinutes(), // 分
    's+': source.getSeconds(), // 秒
    'q+': Math.floor((source.getMonth() + 3) / 3), // 季度
    'f+': source.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (source.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
    }
  }
  return format
}

/**
 * 指定班级是否名额紧张
 * @param  {int}    当前人数
 * @param  {int}    最大人数
 * @return {bool}   是名额紧张
 */
export const isFew = (currentNum, maxNum) => {
  let result = false
  if (currentNum > 0 && maxNum > 0) {
    if (maxNum > 10) {
      if (maxNum - currentNum <= 2 && maxNum - currentNum > 0) {
        result = true
      }
    } else {
      if ((maxNum - currentNum) / (maxNum * 1.0) <= 0.2 && maxNum - currentNum > 0) {
        result = true
      }
    }
  }
  return result
}

// 教学方式
export const teachingMethodUtil = (methodCode) => {
  let iconText = ''
  if (methodCode.length) {
    let methods = methodCode.split(',')
    methods.forEach(val => {
      if (val === '211') {
        iconText += '面授+'
      } else if (val === '223') {
        iconText += '双师+'
      } else if (val === '227') {
        iconText += '录播+'
      } else if (val === '229') {
        iconText += '直播+'
      }else if (val === '233') {
        iconText += '线上+'
      } else if (val === '239') {
        iconText += '智慧学习+'
      }
    })
    if (iconText.length) {
      iconText = iconText.substr(0, iconText.length - 1)
    }
    return iconText
  } else {
    return iconText
  }
}

// 获取课时 - 带小数点
export const getPeriodTimes = (minutes) => {
  if (!minutes) return 0
  let times = (minutes / 60).toFixed(1).toString()

  return Number(times.replace('.0', ''))
}

// 课时，课次
export const getClassLessonTimesUtil = (lessonTimes, realMinutes) => {
  let text = ''
  realMinutes = getPeriodTimes(realMinutes)
  if (lessonTimes > 0 && realMinutes > 0) {
    text = realMinutes + '课时 /' + lessonTimes + '课次'
  } else if (lessonTimes > 0) {
    text = lessonTimes + '课次'
  } else if (realMinutes > 0) {
    text = realMinutes + '课时'
  }
  return text
}

// 住宿班
export const getClassStayUtil = (modeCodes) => {
  let isStay = false
  if (modeCodes.length) {
    if (modeCodes.indexOf('103') !== -1) {
      isStay = true
    }
  }
  return isStay
}

// 名额紧张
export const isFewUtil = (currentNum, maxNum, bmState) => {
  let result = false
  if (bmState < 4 && bmState > 0) {
    if (currentNum > 0 && maxNum > 0) {
      if (maxNum <= 10) {
        if (maxNum - currentNum <= 2 && maxNum - currentNum > 0) {
          result = true
        }
      } else {
        if ((maxNum - currentNum) / (maxNum * 1.0) <= 0.2 && maxNum - currentNum > 0) {
          result = true
        }
      }
    }
  }
  return result
}

/**
 * 判断当前运行环境
 * @returns {String} 'miniprogram' | 'app' | 'h5'
 */
export const getCurrentEnv = () => {
  const ua = navigator.userAgent.toLowerCase()


  // 判断是否在小程序环境
  if (ua.includes('miniprogram')) {
    console.log('miniprogramminiprogramminiprogramminiprogram')
    // 进一步判断是否在微信小程序
    if (window.__wxjs_environment === 'miniprogram' || 
        window.wx && window.wx.miniProgram) {
      return 'miniprogram'
    }
  }

  // 判断是否在App环境（新东方App）
  if (ua.includes('xdfapp') || ua.includes('xdf-app') || 
      ua.includes('neworiental') || ua.includes('xdf')) {
    return 'app'
  }

  
  // 默认为H5环境
  return 'h5'
}

/**
 * 跳转详情页面的统一方法
 * @param {String} cityCode 城市代码
 * @param {String|Number} schoolId 学校ID
 * @param {String|Number} classCode 班级代码
 */
export const navigateToDetail = (cityCode, schoolId, classCode) => {
  // 检查必要参数
  if (!cityCode || !schoolId || !classCode) {
    console.error('navigateToDetail: 缺少必要参数', { cityCode, schoolId, classCode })
    return
  }
  
  const env = getCurrentEnv()
  console.log('env', env)
  
  try {
    switch (env) {
      case 'miniprogram':
        // 小程序环境跳转
        navigateToMiniProgram(cityCode, schoolId, classCode)
        break
        
      case 'app':
      case 'h5':
      default:
        // App和H5环境跳转
        navigateToWeb(cityCode, schoolId, classCode, env)
        break
    }
  } catch (error) {
    console.error('navigateToDetail 跳转失败:', error)
  }
}

/**
 * 小程序环境跳转
 */
const navigateToMiniProgram = (cityCode, schoolId, classCode) => {
  // 只使用课程详情页面路径
  const url = '/pages/course-detail/index'
  
  // 构建查询参数
  const queryParams = {
    cityCode,
    schoolId,
    classCode
  }
  
  const query = `?${Object.keys(queryParams).map(key => `${key}=${queryParams[key]}`).join('&')}`
  
  if (window.wx && window.wx.miniProgram) {
    // 微信小程序
    window.wx.miniProgram.navigateTo({
      url: `${url}${query}`,
      fail: (error) => {
        console.error('小程序跳转失败，降级为H5跳转:', error)
        navigateToWeb(cityCode, schoolId, classCode, 'h5')
      }
    })
  } else {
    // 其他小程序环境
    console.warn('小程序环境检测失败，使用H5跳转')
    navigateToWeb(cityCode, schoolId, classCode, 'h5')
  }
}

/**
 * App和H5环境跳转
 */
const navigateToWeb = (cityCode, schoolId, classCode, env) => {
  // 构建URL
  const soukeWebUrl = configData.soukeWebUrl || 'https://m.souke.xdf.cn'
  const url = `${soukeWebUrl}/item/${cityCode}-${schoolId}-${classCode}.html`
  
  if (env === 'app') {
    // App环境：尝试使用 moonbridge 调用原生方法
    let xdfMoonBridge = null
    try {
      xdfMoonBridge = require('@xdf/h5-app-moonbridge')
    } catch (error) {
      console.warn('无法导入 moonbridge，使用降级方案')
    }
    
    if (xdfMoonBridge && xdfMoonBridge.nativeModule && xdfMoonBridge.nativeModule.openPage) {
      const scheme = 'xdfapp://student/web'
      const data = {
        url,
        fullscreen: '1',
        isImmersive: '1'
      }
      
      try {
        xdfMoonBridge.nativeModule.openPage({ scheme, data })
        return
      } catch (error) {
        console.error('App内跳转失败，降级为网页跳转:', error)
      }
    }
  }
  
  // H5环境或App降级：直接使用原生跳转
  window.location.href = url
}
